import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "../styles/PickupPointMap.css";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";

// Correction pour les icônes par défaut de Leaflet dans Webpack
delete L.Icon.Default.prototype._getIconUrl;


// Fusionner les options de l'icône par défaut de Leaflet
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

const PickupPointMap = ({ points, onSelect }) => {
  // Définir le centre de la carte sur le premier point s'il existe, sinon Paris par défaut
  const defaultPosition =
    points.length > 0
      ? [parseFloat(points[0].latitude), parseFloat(points[0].longitude)]
      : [48.8566, 2.3522];

  return (
    <div className="pickup-point-map">
      <MapContainer center={defaultPosition} zoom={13} style={{ height: "70vh", width: "100%", borderBottomLeftRadius: 15, borderBottomRightRadius: 15}}>
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {points.map((point) => (
          <Marker key={point.id} position={[parseFloat(point.latitude), parseFloat(point.longitude)]}>
            <Popup>
              <div>
                <h4>{point.name}</h4>
                <p>
                  {point.street} {point.house_number}, {point.postal_code} {point.city}
                </p>
                <p>Distance : {point.distance} m</p>
                <button onClick={() => onSelect(point)}>Choisir ce point</button>
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
};

export default PickupPointMap;
